import { useEffectOnce } from 'react-use';
import { useBodyClass } from '@toss/react';
import { useRouter } from 'next/router';
import { logger } from '@zep/core-logger';
import { LandingBusinessProposal, LandingExperience, LandingFAQ, LandingIntro, LandingMyMetaverse, LandingPremium, LandingUsedClient, LandingWhy } from '../../components';
import { useMotion } from '../../hooks';
import { useOfficeLanding } from '../../services';
import S from './Landing.module.scss';
export const OfficeLandingPageView = () => {
  const {
    locale
  } = useRouter();
  const {
    data
  } = useOfficeLanding();
  useMotion([locale, data]);
  useBodyClass('use-typography');
  useEffectOnce(() => {
    logger.track('enter_office_landing');
  });
  return <main className={S.main} data-sentry-component="OfficeLandingPageView" data-sentry-source-file="office.tsx">
      {data?.OfficeIntro && <LandingIntro title={data?.OfficeIntro.title} source={data?.OfficeIntro.source} buttonText={data?.OfficeIntro.buttonText} buttonLink={data?.OfficeIntro.buttonLink} onButtonClick={ctaClickTracker('top')} />}
      {data?.OfficeExperience && <LandingExperience title={data?.OfficeExperience.title} spaces={data?.OfficeExperience.spaces} buttonText={data?.OfficeExperience.buttonText} buttonLink={data?.OfficeExperience.buttonLink} />}
      {data?.OfficeUsedClient && <LandingUsedClient title={data?.OfficeUsedClient.title} description={data?.OfficeUsedClient.description} logos={data?.OfficeUsedClient.logos} buttonText={data?.OfficeUsedClient.buttonText} buttonLink={data?.OfficeUsedClient.buttonLink} onButtonClick={ctaClickTracker('company')} />}
      {data?.OfficeWhy && <LandingWhy title={data?.OfficeWhy.title} description={data?.OfficeWhy.description} list={data?.OfficeWhy.list} />}
      {data?.OfficeMyMetaverse && <LandingMyMetaverse title={data?.OfficeMyMetaverse.title} list={data?.OfficeMyMetaverse.list} />}
      {data?.LandingBusinessProposal && <LandingBusinessProposal title={data?.LandingBusinessProposal.title} description={data?.LandingBusinessProposal.description} buttonText={data?.LandingBusinessProposal.buttonText} buttonLink={data?.LandingBusinessProposal.buttonLink} />}
      {data?.OfficePremium && <LandingPremium title={data?.OfficePremium.title} description={data?.OfficePremium.description} features={data?.OfficePremium.features} buttonText={data?.OfficePremium.buttonText} buttonLink={data?.OfficePremium.buttonLink} logo="office" backgroundColor="gray" onButtonClick={ctaClickTracker('premium')} />}
      {data?.OfficeFAQ && <LandingFAQ title={data?.OfficeFAQ.title} list={data?.OfficeFAQ.list} buttonText={data?.OfficeFAQ.buttonText} buttonLink={data?.OfficeFAQ.buttonLink} />}
    </main>;
};
function ctaClickTracker(place: string) {
  return () => {
    logger.track('office_landing_inquiry', {
      place
    });
  };
}